module.exports = __webpack_public_path__ + "static/media/3_zh.5990358e.png";